import { useState, useEffect } from "react";

export default function useErrorState() {
  const errorStateName = "error";
  const [isInErrorState, setIsInErrorState] = useState(false);
  const [errorState, setState] = useState("ok");
  const lastState = errorState === errorStateName ? "ok" : errorStateName;

  function setErrorState(isError) {
    setIsInErrorState(isError);
    setState(isError ? errorStateName : "ok");
  }

  useEffect(() => {
    const root = window.document.documentElement;
    if (lastState) {
      root.classList.remove(lastState);
    }
    if (errorState) {
      root.classList.add(errorState);
    }

    //console.log("change", state, lastState);
  }, [errorState, lastState]);

  return [isInErrorState, setErrorState];
}
